import { WidgetConfiguration } from '../../widget-configs/models/widget-configuration';
import { CashBalancesViewType } from './cash-balances.model';


export class CashBalanceConfiguration {
  WidgetConfigurationId: number;
  GroupByField1: string;
  GroupByField2: string;
  View: CashBalancesViewType;
  Currency: string;
}

export class SaveCashBalanceWidgetConfigurationRequest {
  widgetConfiguration: WidgetConfiguration;
  cashBalanceConfiguration: CashBalanceConfiguration;
}

